import { defineComponent as _defineComponent } from 'vue'
import Vue, { ref, Ref } from "vue";
import moment from "moment";
import {
  BIconClock,
  BIconCalendar,
  BFormTimepicker,
  BFormDatepicker,
  VBTooltip,
  BButton,
} from "bootstrap-vue";
import useStore from "@/store/useStore";
import { useRoute, useRouter } from "vue-router/composables";


export default /*#__PURE__*/_defineComponent({
  __name: 'crawl-time',
  setup(__props) {

Vue.directive("b-tooltip", VBTooltip);

const store = useStore();
const router = useRouter();
const route = useRoute();

const time: Ref<Date> = ref(new Date(store.network.time.getTime()));
const crawlTime: Ref<string> = ref(moment(time.value).format("HH:mm:ss"));
const minSelectedDate: Date = store.measurementsStartDate;

function timeTravel() {
  router.push({
    name: route.name ? route.name : undefined,
    params: route.params,
    query: {
      view: route.query.view,
      "no-scroll": "1",
      network: route.query.network,
      at: moment(time.value)
        .hours(Number(crawlTime.value.substring(0, 2)))
        .minutes(Number(crawlTime.value.substring(3, 5)))
        .toISOString(),
    },
  });
}

return { __sfc: true,store, router, route, time, crawlTime, minSelectedDate, timeTravel, BIconClock, BIconCalendar, BFormTimepicker, BFormDatepicker, BButton }
}

})